// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"XZ-z","displaySixCardTiles":"YZ-z"};